import { trackEvent } from 'fathom-client';

import { selectCanAccessDesigns } from 'features/challenges/slice';
import { selectCurrentUser } from 'features/auth/slice';
import { useSelector } from 'react-redux';

import {
  formatDate,
  Icon,
  pluralize,
} from '@frontendmentorio/design-system-v2';

import ConfirmButton from 'features/shared/ConfirmButton';
import NoCreditsLockMessage from 'features/shared/NoCreditsLockMessage';
import ProLockMessage from 'features/shared/ProLockMessage';

export const renderDesignConfirmation = (currentUser, challenge) => {
  const { credits, subscription } = currentUser;

  if (
    currentUser.purchases.includes(challenge.id) ||
    !isFinite(+credits.designs)
  ) {
    return false;
  }

  const description = [
    `You've got **${credits.designs} ${pluralize(
      credits.designs,
      'credit',
      null,
      false
    )} remaining**. After downloading the design you'll have **${
      credits.designs - 1
    }** left.`,
  ];

  if (subscription?.nextPaymentAt) {
    description[0] += ` You will receive more credits on **${formatDate(
      subscription.nextPaymentAt
    )}**.`;
  }

  if (
    subscription?.status === 'active' &&
    subscription?.interval === 'monthly'
  ) {
    description.push(
      "If you'd like unlimited downloads, you can switch to our yearly plan by emailing us at [hi@frontendmentor.io](mailto:hi@frontendmentor.io)."
    );
  }

  return {
    button: 'Accept and download',
    description: description.join('\n\n'),
    id: 'design-confirmation',
    title: 'Just to confirm...',
  };
};

export default function DownloadDesignButton({
  challenge,
  onClick: handleClick,
  modal,
}) {
  const canAccessDesigns = useSelector((state) =>
    selectCanAccessDesigns(state, challenge)
  );
  const currentUser = useSelector(selectCurrentUser);

  const handleDownloadDesign = () => {
    handleClick();
    trackEvent(`Design Download: ${challenge.title}`);
  };

  if (canAccessDesigns) {
    return (
      <ConfirmButton
        className="gap-2"
        level="secondary"
        modal={modal}
        onClick={handleDownloadDesign}
      >
        Download Figma file{' '}
        <Icon className="text-white" name="cloud-arrow-down" />
      </ConfirmButton>
    );
  }

  if (!currentUser?.hasActiveSubscription) {
    return (
      <ProLockMessage withCTA>
        Unlock Pro to get design file access and practice building projects like
        the professionals.
      </ProLockMessage>
    );
  }

  return <NoCreditsLockMessage currentUser={currentUser} />;
}
